// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"da04780e","703":"ddaf71bd","787":"ec92ac9e"}[chunkId] + ".chunk.js";
};